import DashboardLayout from '../components/DashboardLayout';
import SecuritySettings from '../components/SecuritySettings';

const SecurityPage = () => (
  <DashboardLayout title="Security centre">
    <div className="section">
      <div className="card hero-card">
        <span className="eyebrow">Security</span>
        <h3 style={{ margin: '0.4rem 0' }}>Strengthen your sign-in</h3>
        <p style={{ color: 'var(--dark)', marginBottom: '0.5rem' }}>
          Enable TOTP or register a new passkey to harden your Gate.haus account. You can also disable factors from here.
        </p>
        <p style={{ color: 'var(--gray)', margin: 0 }}>We recommend keeping both TOTP and passkeys active for resilience.</p>
      </div>
      <SecuritySettings />
    </div>
  </DashboardLayout>
);

export default SecurityPage;
